import { render, staticRenderFns } from "./PartnersList.vue?vue&type=template&id=4d71b9c1&scoped=true"
import script from "./PartnersList.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnersList.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PartnersList.vue?vue&type=style&index=0&id=4d71b9c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d71b9c1",
  null
  
)

export default component.exports